import { IJudgmentPunishmentType } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentPunishmentType';
import { IKnmJudgmentPunishmentTypeSelectOption } from '../interfaces/IKnmJudgmentPunishmentTypeSelectOption';

export const createJudgmentPunishmentTypeSelectOption = (
  erknmJudgmentPunishmentType: IJudgmentPunishmentType,
): IKnmJudgmentPunishmentTypeSelectOption => ({
  ...erknmJudgmentPunishmentType,
  label: erknmJudgmentPunishmentType.name,
  value: erknmJudgmentPunishmentType.id,
  hasText: erknmJudgmentPunishmentType.hasText,
  hasIndexAndAmount: erknmJudgmentPunishmentType.hasIndexAndAmount,
});
